import { useEffect, useMemo, useRef, useState } from 'react'
import { contractTemplateApi } from '@pages/Admin/PlatformSettings2/SettingUpContracts/api/contractTemplate.api'
import type { ContractTemplate } from '@pages/Admin/PlatformSettings2/SettingUpContracts/api/contractTemplate.types'
import { useAddAlert } from '@/hooks/useAddAlert'
import { getErrorText } from '../utils/getErrorText'

export const useContractTemplates = (active: boolean) => {
  const addAlert = useAddAlert()
  const addAlertRef = useRef(addAlert)
  const [templates, setTemplates] = useState<ContractTemplate[]>([])
  const [templatesLoading, setTemplatesLoading] = useState(false)

  useEffect(() => {
    addAlertRef.current = addAlert
  }, [addAlert])

  useEffect(() => {
    if (!active) return undefined

    let isCancelled = false
    setTemplatesLoading(true)

    contractTemplateApi
      .getList()
      .then((list) => {
        if (!isCancelled) {
          setTemplates(list)
        }
      })
      .catch((error) => {
        if (!isCancelled) {
          addAlertRef.current({
            title: 'Ошибка',
            text: getErrorText(error, 'Не удалось загрузить шаблоны договоров'),
            type: 'error',
          })
        }
      })
      .finally(() => {
        if (!isCancelled) {
          setTemplatesLoading(false)
        }
      })

    return () => {
      isCancelled = true
    }
  }, [active])

  const templateOptions = useMemo(
    () =>
      templates
        .filter((template) => template.is_active !== 0)
        .map((template) => ({
          label: template.name,
          value: String(template.id),
        })),
    [templates],
  )

  return {
    templates,
    templatesLoading,
    templateOptions,
  }
}
